import { FontFamily } from '@/model/Font'
import { SelectOption } from '@/model/SelectOption'

export const computeFontFamilyOption = (fontFamilyName: FontFamily): SelectOption<FontFamily> => ({
  id: fontFamilyName,
  value: fontFamilyName,
  label: fontFamilyName,
})
